module.exports = __webpack_public_path__ + "assets/img/sessions.cefd3243.png";